import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/workpath0/src/components/MDXLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{props.pageContext.frontmatter.title}</h1>
    <p>{`All orders placed on Holy Shirts & Pants include free shipping. Depending on the carrier used shipping can take up to 8-10 days from the date the item is shipped. Expect to wait longer during the holidays.`}</p>
    <p>{`You can always contact us for any shipping question at `}<a parentName="p" {...{
        "href": "mailto:info@example.com"
      }}>{`info@example.com`}</a>{`.`}</p>
    <p><strong parentName="p">{`Shipping restictions`}</strong><br />{`
We will not ship to the following locations within the continental United States: ALABAMA, INDIANA, ARKANSAS, RHODE ISLAND, VERMONT, WISCONSIN, TENNESSEE, SARASOTA, FL, UNION C. MI, SAN DIEGO, CA, and DENVER, CO.
We will not ship to any country where shipping is prohobited.
We maintain the right to refuse shipping to any location or for any reason whatsoever. Orders placed but not shipped will be refunded in full.`}</p>
    <p><strong parentName="p">{`International shipments`}</strong><br />{`
We ship though a number of different international shipping carriers including UPS, FedEx and Red Cargo. Depending on order size and specific items included your items may arrive in multiple shipments. Any customs and import duties are the sole responsibility of the customer.`}</p>
    <p><strong parentName="p">{`Missing or lost packages`}</strong><br />{`
All items purchased from Holy Shirts & Pants are made pursuant to a shipment contract. This basically means that the risk of loss and title for such items pass to you upon our delivery to the courier.`}</p>
    <p><strong parentName="p">{`Return and exchanges`}</strong><br />{`
Return and exchange information is available in our `}<a parentName="p" {...{
        "href": "return-policy"
      }}>{`Return Policy`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      